module.exports = __webpack_public_path__ + "static/media/loading_spinner.71e80089.svg";